<form [formGroup]="form" *ngIf="entity && form" class="mb-0" novalidate>
  <ng-container *ngIf="orientation === 'horizontal'">
    <div
      class="form-group"
      [ngClass]="{ 'mb-0': !showLabel && !templateForPermitForm,    'p-0': templateForPermitForm
 }"
    >
      @if(!templateForPermitForm){
      <input
        type="text"
        class="form-control"
        [formControlName]="entity.templateCode"
        [placeholder]="showLabel ? entity.label : placeholder"
        [(ngModel)]="entity.value"
        *ngIf="!entity.isMultiline"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
        [required]="entity.isRequired"
      />

      <textarea
        class="form-control"
        [formControlName]="entity.templateCode"
        [placeholder]="showLabel ? entity.label : placeholder"
        *ngIf="entity.isMultiline"
        rows="5"
        [(ngModel)]="entity.value"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
        [required]="entity.isRequired"
      ></textarea>
      }
      <!-- added by priya 17-12-2025 -->
      @else {
      <!-- <wm-common-textfield
        *ngIf="!entity.isMultiline"
        [data]="{
          label: showLabel ? entity.label : placeholder,
          value: entity.value ?? '',
          placeholder: showLabel ? entity.label : placeholder,
          required: entity.isRequired,
          onChange: onFieldChange.bind(this)
        }"
      >
      </wm-common-textfield>
      <wm-common-textfield
        *ngIf="entity.isMultiline"
        [data]="{
        label: showLabel ? entity.label : placeholder,
        value: entity.value ?? '',
        placeholder: showLabel ? entity.label : placeholder,
        required: entity.isRequired,
        type:'text-area',
        textAreaRows:5,
        onChange: onFieldChange.bind(this)
      }"
      >
      </wm-common-textfield> -->
      <!-- <wm-common-angular-textfield
        *ngIf="entity.isMultiline"
        [formControlName]="entity.templateCode"
        [(ngModel)]="entity.value"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
        [type]="'text'"
        [placeholder]="showLabel ? entity.label : placeholder"
        [isEditable]="entity.isEditable"
        [required]="entity.isRequired"
        [isEditable]="true"
      ></wm-common-angular-textfield>

      <wm-common-angular-textfield
        *ngIf="entity.isMultiline"
        [formControlName]="entity.templateCode"
        [(ngModel)]="entity.value"
        [name]="entity.templateCode"
        [id]="entity.templateCode"
        [type]="'text'"
        [placeholder]="showLabel ? entity.label : placeholder"
        [isEditable]="entity.isEditable"
        [required]="entity.isRequired"
        [isEditable]="true"
      ></wm-common-angular-textfield> -->
      <wm-common-textfield
      *ngIf="!entity.isMultiline"
      [data]="{
      label: showLabel ? entity.label : '',
      instructions: entity.instructions,
      isHelpText: entity.isHelpText,
      id: entity.templateCode,
      required:entity.isRequired,
      value: entity.value,
      formatValidation: entity.restrictedFormat
    }"
      [formControlName]="entity.templateCode"
    (valueChange)="entity.value = $event"
      >
    </wm-common-textfield>

      <wm-common-textfield
      *ngIf="entity.isMultiline"
      [data]="{
      label: showLabel ? entity.label : '',
      instructions: entity.instructions,
      isHelpText: entity.isHelpText,
      id: entity.templateCode,
      required:entity.isRequired,
      value: entity.value,
      type: 'text-area'
    }"
      [formControlName]="entity.templateCode"
    (valueChange)="entity.value = $event"
      >
    </wm-common-textfield>

      }
      <!-- end by priya 17-12-2025 -->
    </div>
  </ng-container>
  <ng-container *ngIf="orientation === 'vertical'">
    @if(!templateForPermitForm){
    <wm-de-label
      *ngIf="showLabel"
      [entity]="entity"
      [for]="entity.templateCode"
    ></wm-de-label>

    <input
      type="text"
      class="form-control"
      [formControlName]="entity.templateCode"
      [placeholder]="placeholder"
      [(ngModel)]="entity.value"
      *ngIf="!entity.isMultiline"
      [name]="entity.templateCode"
      [id]="entity.templateCode"
      [required]="entity.isRequired"
    />

    <textarea
      class="form-control"
      [formControlName]="entity.templateCode"
      [placeholder]="placeholder"
      *ngIf="entity.isMultiline"
      rows="5"
      [(ngModel)]="entity.value"
      [name]="entity.templateCode"
      [id]="entity.templateCode"
      [required]="entity.isRequired"
    ></textarea>
    }
    <!-- added by priya 17-12-2025 -->
    @else {
    <!-- <wm-common-textfield
        *ngIf="!entity.isMultiline"
        [data]="{
          label: showLabel ? entity.label : placeholder,
          required: entity.isRequired,

        }"
        [formControlName]="entity.templateCode"
        [ngModel]="entity.value ?? ''"
    (ngModelChange)="entity.value = $event ?? ''"
      >
      </wm-common-textfield>


      <wm-common-textfield
      *ngIf="entity.isMultiline"
      [data]="{
        label: showLabel ? entity.label : placeholder,
        value: entity.value ?? '',
        placeholder: showLabel ? entity.label : placeholder,
        required: entity.isRequired,
        textAreaRows:4,
        onChange: onFieldChange.bind(this),
        type:'text-area'
      }"
    ></wm-common-textfield> -->
    <!-- <wm-common-angular-textfield
      *ngIf="!entity.isMultiline"
      [formControlName]="entity.templateCode"
      [(ngModel)]="entity.value"
      [name]="entity.templateCode"
      [id]="entity.templateCode"
      [type]="'text'"
      [placeholder]="showLabel ? entity.label : placeholder"
      [isEditable]="entity.isEditable"
      [required]="entity.isRequired
      [inputClass]="'form-control'"
      [isEditable]="true"
    ></wm-common-angular-textfield> -->
    <!-- <wm-common-angular-textfield
      *ngIf="!entity.isMultiline"
      [formControlName]="entity.templateCode"
      [(ngModel)]="entity.value"
      [name]="entity.templateCode"
      [id]="entity.templateCode"
      [type]="'text'"
      [label]="showLabel ? entity.label : placeholder"
      [isEditable]="entity.isEditable"
      [required]="entity.isRequired"
      [isEditable]="true"
    ></wm-common-angular-textfield> -->


    <wm-common-textfield
    *ngIf="!entity.isMultiline"
    [data]="{
    label: showLabel ? entity.label : '',
    instructions: entity.instructions,
    isHelpText: entity.isHelpText,
    id: entity.templateCode,
    required:entity.isRequired,
    value: entity.value,
    formatValidation: entity.restrictedFormat
  }"
    [formControlName]="entity.templateCode"
  (valueChange)="entity.value = $event"
    >
  </wm-common-textfield>
    <!-- <wm-common-angular-textfield
      *ngIf="entity.isMultiline"
      [formControlName]="entity.templateCode"
      [(ngModel)]="entity.value"
      [name]="entity.templateCode"
      [id]="entity.templateCode"
      [type]="'text'"
      [label]="showLabel ? entity.label : placeholder"
      [isEditable]="entity.isEditable"
      [required]="entity.isRequired"
      [isEditable]="true"
    ></wm-common-angular-textfield> -->
    <wm-common-textfield
    *ngIf="entity.isMultiline"
    [data]="{
    label: showLabel ? entity.label : '',
    instructions: entity.instructions,
    isHelpText: entity.isHelpText,
    id: entity.templateCode,
    required:entity.isRequired,
    value: entity.value,
    type: 'text-area'
  }"
    [formControlName]="entity.templateCode"
  (valueChange)="entity.value = $event"
    >
  </wm-common-textfield>

    }
    <!-- end by priya 17-12-2025 -->
  </ng-container>
</form>
